import { render } from "./MultipleFileUpload.vue?vue&type=template&id=27d6d3e0"
import script from "./MultipleFileUpload.vue?vue&type=script&lang=js"
export * from "./MultipleFileUpload.vue?vue&type=script&lang=js"

import "./MultipleFileUpload.vue?vue&type=style&index=0&id=27d6d3e0&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__